module.exports = __webpack_public_path__ + "img/index_kyzx_dsj.13dfea4a.png";